import { render, staticRenderFns } from "./dialog_1.vue?vue&type=template&id=0992551f&scoped=true"
import script from "./dialog_1.vue?vue&type=script&lang=js"
export * from "./dialog_1.vue?vue&type=script&lang=js"
import style0 from "./dialog_1.vue?vue&type=style&index=0&id=0992551f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992551f",
  null
  
)

export default component.exports